import { useInsightsSectionContent } from './useInsightsSectionContent';
import { parseInsightsHeritageContent } from '../utils/insightsContent';

export const useInsightsHeritageContent = () =>
  useInsightsSectionContent(parseInsightsHeritageContent);
